module.exports = __webpack_public_path__ + "img/index.746b1f9a.gif";